import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal.tsx';
import type { SiteConfig } from '../../siteContentTypes.ts';

export function Faq({ config }: { config: SiteConfig }) {
  const [openId, setOpenId] = useState<string | null>(null);
  const items = config.faq.items.filter((f) => f.visible).sort((a, b) => a.order - b.order);
  if (items.length === 0) return null;

  return (
    <section id="faq" style={{ padding: '56px 24px', maxWidth: 760, margin: '0 auto' }}>
      <Reveal>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, marginBottom: 28 }}>{config.faq.title}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {items.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div key={item.id} className="card" style={{ padding: 0, overflow: 'hidden' }}>
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 12,
                    padding: '16px 18px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: 14.5,
                    fontWeight: 700,
                    color: 'var(--text)',
                  }}
                  aria-expanded={isOpen}
                >
                  {item.question}
                  <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }} style={{ flexShrink: 0 }}>
                    <ChevronDown size={18} color="var(--text-tertiary)" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.22 }}
                      style={{ overflow: 'hidden' }}
                    >
                      <div style={{ padding: '0 18px 16px', fontSize: 13.5, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
                        {item.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </Reveal>
    </section>
  );
}
